import { PreviewTable } from './components';
import { useUsersTable } from './hooks/useUsersTable.ts';

interface IUsersTableProps {
  groupName?: string;
  footerWidth?: string | number;
  isLoading?: boolean;
}

export const UsersTable = ({
  groupName,
  footerWidth,
  isLoading,
}: IUsersTableProps) => {
  const {
    entries,
    columns,
    totalCount,
    isLoading: loading,
    filters,
    onFilterChange,
  } = useUsersTable(groupName);

  return (
    <PreviewTable
      rows={entries}
      columns={columns}
      filters={filters}
      setFilters={onFilterChange}
      totalCount={totalCount}
      loading={isLoading || loading}
      type='users'
      displayHead={groupName === undefined}
      footerWidth={footerWidth}
    />
  );
};
